export function canRenderAction(errorAction, errorActionText) {
  return errorAction && errorActionText
}
